export interface HeroCard {
  id: string;
  label: string;
  title: string;
  desc: string;
  status: string;
  tone: 'ok' | 'warn' | 'calm';
  meta: string;
  image: string;
  wide?: boolean;
}

export const heroCards: HeroCard[] = [
  {
    id: 'main',
    label: '官网主入口',
    title: '主线路 · 常态可用',
    desc: '访问顺畅时优先使用主线路，加载更快、内容更完整。',
    status: '线路正常',
    tone: 'ok',
    meta: '状态更新于 09:40',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20paper%20texture%20in%20deep%20terracotta%20and%20warm%20cream%20tones%2C%20soft%20folded%20paper%20shadows%20and%20grain%2C%20minimal%20magazine%20cover%20composition%2C%20no%20text&width=1000&height=640&seq=hl-hero-main&orientation=landscape',
    wide: true,
  },
  {
    id: 'alt',
    label: '备用地址',
    title: '备用线路 A',
    desc: '主线路波动时切换使用。',
    status: '可用',
    tone: 'ok',
    meta: '10 分钟前更新',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20beige%20gradient%20poster%20with%20fine%20paper%20grain%20and%20layered%20soft%20shapes%2C%20editorial%20minimal%20art%20texture%2C%20no%20text&width=640&height=820&seq=hl-hero-alt&orientation=portrait',
  },
  {
    id: 'change',
    label: '换地址说明',
    title: '地址变更指引',
    desc: '旧地址失效后的正确做法。',
    status: '建议阅读',
    tone: 'calm',
    meta: '长期有效',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20moss%20green%20and%20cream%20torn%20paper%20collage%20with%20dot%20grid%20pattern%2C%20minimal%20editorial%20design%20texture%20with%20soft%20shadows%2C%20no%20text&width=640&height=820&seq=hl-hero-change&orientation=portrait',
  },
];

export interface StatusItem {
  time: string;
  date: string;
  title: string;
  desc: string;
  tag: string;
  tone: 'ok' | 'warn' | 'info';
}

export const statusFeed: StatusItem[] = [
  {
    time: '09:40',
    date: '今天',
    title: '主线路恢复正常访问',
    desc: '官网主入口已完成线路优化，当前打开速度恢复正常，可优先使用主地址访问。',
    tag: '恢复正常',
    tone: 'ok',
  },
  {
    time: '08:15',
    date: '今天',
    title: '部分网络环境出现波动',
    desc: '监测到少数地区访问主线路时出现加载缓慢，建议暂时切到备用地址 A 继续浏览最新内容。',
    tag: '访问波动',
    tone: 'warn',
  },
  {
    time: '22:30',
    date: '昨天',
    title: '备用地址 A 已同步更新',
    desc: '备用线路内容与主站保持一致，若主地址打不开，可直接使用备用地址进入，无需重新注册。',
    tag: '地址更新',
    tone: 'info',
  },
  {
    time: '18:05',
    date: '昨天',
    title: '完成新一轮可用性检测',
    desc: '对全部线路进行连通性检测，主线路与备用线路 A 均通过测试，其余线路进入观察名单。',
    tag: '例行检测',
    tone: 'ok',
  },
  {
    time: '11:20',
    date: '前天',
    title: '旧访问地址正式停止服务',
    desc: '历史旧地址已不再提供服务，继续使用会出现打不开的情况，请统一改用本页提供的最新地址。',
    tag: '旧址停用',
    tone: 'warn',
  },
  {
    time: '07:45',
    date: '前天',
    title: '换地址流程说明发布',
    desc: '整理了地址变更后的完整操作步骤，遇到换地址不用慌，按步骤操作即可快速恢复访问。',
    tag: '指引发布',
    tone: 'info',
  },
];

export interface AddressItem {
  id: string;
  name: string;
  code: string;
  note: string;
  status: string;
  tone: 'ok' | 'warn' | 'busy';
  updated: string;
  primary?: boolean;
}

export const backupAddresses: AddressItem[] = [
  {
    id: 'main',
    name: '官网主线路',
    code: 'MAIN',
    note: '官方主入口，日常访问首选，内容与更新最及时。',
    status: '正常可用',
    tone: 'ok',
    updated: '今天 09:40',
    primary: true,
  },
  {
    id: 'route-a',
    name: '备用线路 A',
    code: 'ROUTE A',
    note: '主线路打不开时的第一顺位，加载稳定。',
    status: '正常可用',
    tone: 'ok',
    updated: '今天 09:12',
  },
  {
    id: 'route-b',
    name: '备用线路 B',
    code: 'ROUTE B',
    note: '移动网络环境下的优选线路，切换更快。',
    status: '轻微波动',
    tone: 'warn',
    updated: '今天 08:36',
  },
  {
    id: 'route-c',
    name: '备用线路 C',
    code: 'ROUTE C',
    note: '高峰期分流线路，访问人数较多时使用。',
    status: '正常可用',
    tone: 'ok',
    updated: '昨天 22:30',
  },
  {
    id: 'route-d',
    name: '备用线路 D',
    code: 'ROUTE D',
    note: '长期备用线路，仅在其它线路异常时启用。',
    status: '维护中',
    tone: 'busy',
    updated: '昨天 19:05',
  },
];

export interface StepItem {
  no: string;
  icon: string;
  title: string;
  desc: string;
}

export const accessSteps: StepItem[] = [
  {
    no: '01',
    icon: 'ri-refresh-line',
    title: '先刷新，别急着换',
    desc: '打开主地址遇到打不开，先刷新一次页面并确认网络正常，很多情况只是短暂波动。',
  },
  {
    no: '02',
    icon: 'ri-route-line',
    title: '切换备用地址',
    desc: '刷新无效就切到「访问状态」里显示正常可用的备用地址，内容与主站一致，无需重新登录。',
  },
  {
    no: '03',
    icon: 'ri-bookmark-3-line',
    title: '收藏本页地址',
    desc: '把本指引页收藏起来。以后换地址、打不开时，都能从这里找到当前最新的可用入口。',
  },
  {
    no: '04',
    icon: 'ri-history-line',
    title: '按指引重新进入',
    desc: '地址正式变更后，旧地址会失效。按本页「换地址说明」重新进入，即可继续顺畅浏览。',
  },
];

export interface TrustItem {
  icon: string;
  title: string;
  desc: string;
}

export const trustItems: TrustItem[] = [
  {
    icon: 'ri-shield-check-line',
    title: '官方唯一指引',
    desc: '本页由官网维护，只发布经过验证的可用入口，杜绝来源不明的地址。',
  },
  {
    icon: 'ri-radar-line',
    title: '地址实时更新',
    desc: '线路状态持续监测，一旦有效地址发生变化，本页会第一时间同步。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '安全访问提示',
    desc: '只从本页进入，不轻信他人转发的陌生链接，避免进入仿冒站点。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '问题可随时查',
    desc: '打不开、换地址、地址失效等常见问题，都能在下方 FAQ 找到答案。',
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '黑料官网打不开怎么办？',
    a: '先刷新页面并确认自己的网络连接正常。如果仍然打不开，说明当前地址出现波动，请到本页「备用地址」区域切换到状态为「正常可用」的线路，内容与主站完全一致，无需重新注册。',
  },
  {
    q: '黑料官网怎么进？',
    a: '从本页首屏进入即可。日常访问优先使用「官网主线路」；当主线路打不开时，用备用线路 A 或 B 都能顺畅进入。建议把本页收藏，作为长期固定的入口指引。',
  },
  {
    q: '备用地址多久更新一次？',
    a: '线路状态会持续监测，地址如有变化会尽快同步到本页。访问异常高发的时段，本页更新会更频繁，遇到打不开时刷新本页即可看到最新状态。',
  },
  {
    q: '换了地址之后，旧地址还能用吗？',
    a: '不能。旧地址一旦正式变更就会停止服务，继续使用会出现打不开的情况。请以本页当前展示的地址为准，并删除或替换掉之前保存的旧地址。',
  },
  {
    q: '为什么黑料官网需要换地址？',
    a: '域名或线路调整属于正常维护。当原有的访问地址需要更换时，官网会启用新的入口，同时在本页同步更新，保证老用户不会因为旧地址失效而无法访问。',
  },
  {
    q: '如何确认自己用的是真正的官网？',
    a: '请始终从本页进入，不要点击来源不明的链接或他人转发的短址。只要地址来自本页展示的线路，就是经过验证的官方入口，可以放心使用。',
  },
];

export interface ChannelItem {
  icon: string;
  title: string;
  desc: string;
  action: string;
}

export const updateChannels: ChannelItem[] = [
  {
    icon: 'ri-bookmark-line',
    title: '收藏本页',
    desc: '把本页加入浏览器书签，地址失效时打开即可找到最新入口。',
    action: '收藏指引',
  },
  {
    icon: 'ri-refresh-line',
    title: '定期刷新',
    desc: '遇到打不开时先刷新本页，线路状态与地址变化都会同步显示。',
    action: '查看状态',
  },
  {
    icon: 'ri-notification-3-line',
    title: '开启提醒',
    desc: '需要第一时间知道换地址消息的，可留意本页公告区域的更新提示。',
    action: '了解提醒',
  },
];

export interface NavLink {
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { label: '访问指引', href: '#guide' },
  { label: '备用地址', href: '#addresses' },
  { label: '访问状态', href: '#status' },
  { label: '常见问题', href: '#faq' },
];